<template>
  <div class="">
    <div style="background: #DBE7F2" class="p-2">
      <TitleButton
          btnTitle="Update"
          :showBtn="false"
          :showAddNew="true"
          title="Work status update"
          @onClickAddNewButton="workStatusUpdate"
      />
    </div>

    <div class="card px-2 py-1">
      <div class="row align-items-end">
        <div class="col-12 col-sm-3 col-md-3">
          <div class="d-flex align-items-center justify-content-between filter-label">
            <label class="col-form-label fw-bold">Date</label>
          </div>
          <input
              class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
              tabindex="1"
              type="date"
              placeholder=""
              v-model="formData.date"
          >
        </div>
        <div class="col-12 col-sm-4 col-md-4">
          <div class="d-flex align-items-center justify-content-between filter-label">
            <label for="colFormLabel" class="col-form-label fw-bold">Client: </label>
            <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                <i class="fas fa-search"></i>
            </span>
          </div>
          <AsyncSelect
              @onClear="onClearParty"
              :option-selected="getChangeParty"
              placeholder="Select Client"
              v-model="formData.contactProfile"
              :api-service="fetchContactProfiles"
              :additional-query="additionalContactOption"
              :format-label="formatPatientLabel"
          />
        </div>
        <div class="col-12 col-sm-4 col-md-4">
          <div class="d-flex align-items-center justify-content-between filter-label">
            <label for="colFormLabel" class="col-form-label fw-bold">Select Project: </label>
          </div>
          <AsyncSelect
              ref="projectSelectField"
              placeholder="Select Project"
              v-model="formData.project"
              :api-service="fetchProjects"
              :additional-query="projectAdditionalQuery"
          />
        </div>
        <div class="col-12 col-sm-1 col-md-1">
          <button type="button" @click="getContactWithProjects"
                  class="btn btn-success me-1 waves-effect waves-float waves-light"
          >
            Go
          </button>
        </div>
      </div>
    </div>

    <div class="card" v-for="project in projects">
      <table class="table table-bordered">
        <thead>
        <tr style="font-size: 18px">
          <th colspan="6">{{ project.name }}</th>
          <th class="text-right" colspan="2">Start: {{ formatToDdMmYy(project.start_date) }}</th>
          <th>End: {{ formatToDdMmYy(project.end_date) }}</th>
          <th></th>
        </tr>
        <tr>
          <th class="col-group">Group</th>
          <th class="col-activity-name">Activity Name</th>
          <th class="col-measurement">Measurement Type</th>
          <th class="col-narrow total-color text-right">Total Target</th>
          <th class="col-narrow total-color text-right">Already Achieved</th>
          <th class="col-narrow total-color text-right">Balance</th>
          <th class="col-narrow current-color text-right">Current Target</th>
          <th class="col-narrow current-color">Current Achievement</th>
          <th class="col-note current-color text-center">Note</th>
          <th class="current-color text-center" style="width: 50px">Timesheet</th>
        </tr>
        </thead>
        <tbody>
        <TableTreeBrowser :node="project.project_accounts"/>
        </tbody>
      </table>
    </div>
    <div class="card">
      <h4 v-if="!projects.length" class="text-center card-body">No project found!</h4>
    </div>
  <div class="mb-2"></div>
    <Loader v-if="loading"/>
  </div>
  <ContactDropdownFilter
      v-if="store.state.isModalOpenThree"
      @onSearchContact="onSearchContact"
      :companyRoles="companyRoles"
      :isFilterable="true"
  />
  <ActivityDetailModal ref="activityDetailModal" />
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton'
import Loader from '@/components/atom/LoaderComponent'
import {computed, inject, onMounted, provide, ref} from "vue";
import {useRoute} from "vue-router";
import handleCompanyContact from "@/services/modules/companyContact";
import TableTreeBrowser from "@/views/page/company/contact/work-status/TableTreeBrowser.vue";
import useDate from "@/services/utils/day";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleProjects from "@/services/modules/procurement/project";
import handleContact from "@/services/modules/contact";
import {useStore} from "vuex";
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import handleRole from "@/services/modules/role";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import ActivityDetailModal from "@/components/molecule/procurement/budget/ActivityDetailModal.vue";
import handleTagRegister from "@/services/modules/scm/tag-register";
import handleHospital from '@/services/modules/hospital';

const {formatToDdMmYy} = useDate();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const {fetchContactProfiles} = handleContact();
const {fetchProjects} = handleProjects();
const {fetchContactWithProjectsActivity, projectWorkStatusUpdate} = handleCompanyContact();
const {fetchCompanyDefaultRoles} = handleRole();
const {formatPatientLabel} = useAsyncDropdownHelper();

const projectAdditionalQuery = ref({
  with_donors: 1,
  party_id: ''
})
let projectSelectField = ref(null)
let loading = ref(false)
let projects = ref([])
let companyRoles = ref([])
const activityDetailModal = ref(null)

const onOpenActivityDetailModal = (item) => {
  activityDetailModal.value.openModal(item, companyId.value);
}

const activeContactProfile = ref({ id: null, full_name: '' });
const tagList = ref([]);
const priorityList = ref([]);

provide('activeContactProfile', activeContactProfile);
provide('onOpenActivityDetailModal', onOpenActivityDetailModal);
provide('tagList', tagList);
provide('priorityList', priorityList);

const route = useRoute()
const store = useStore();

//computed
const companyId = computed(() => route.params.companyId);

const formData = ref({
  date: '',
  time: '',
  contact_profile_id: '',
  project: null,
  contactProfile: null,
})

const additionalContactOption = ref({
  with_mobile: 1,
  dealer_id: ''
});

const getChangeParty = (value) => {
  projectAdditionalQuery.value.party_id = value.id
  projectSelectField.value.clear()
}

const onClearParty = () => {
  projectAdditionalQuery.value.party_id = ''
  projectSelectField.value.clear()
}

const onOpenContactSearchModal = () => {
  store.state.isModalOpenThree = true;
}

const onSearchContact = (contact) => {
  formData.value.contactProfile = contact
}

const getCompanyRoles = async () => {
  const res = await fetchCompanyDefaultRoles(`?company_id=${route.params.companyId}&roles=customer,lead`);
  if (res.status) {
    companyRoles.value = res.data
  }
}

const { fetchTagRegisterList } = handleTagRegister();
const { fetchNoteMasterList } = handleHospital();

const getModalList = () => {
  let companyQuery = '?company_id=' + companyId.value;
  fetchTagRegisterList(companyQuery).then(res => {
    if (res.data) tagList.value = res.data;
  });
  let noteMasterQuery = companyQuery + '&is_all=true&status=active&note_type=priority';
  fetchNoteMasterList(noteMasterQuery).then(res => {
    if (res.data) priorityList.value = res.data;
  });
}

const workStatusUpdate = () => {
  loading.value = true
  if (!formData.value.date) formData.value.date = new Date().toISOString().split('T')[0]
  const params = {
    company_id: companyId.value,
    date: formData.value.date,
    contact_profile_id: formData.value.contact_profile_id,
    projects: projects.value
  }
  projectWorkStatusUpdate(params).then(({data, status, message}) => {
    if (!status) {
      return showError(message)
    }
    showSuccess(message)
    getContactWithProjects();
  }).catch((e) => {
    console.log(e)
  }).finally(() => loading.value = false);
}

const getContactWithProjects = () => {
  loading.value = true
  const query = getQuery()

  fetchContactWithProjectsActivity(query).then(({data, status, message}) => {
    if (!status) {
      projects.value = []
      formData.value.contact_profile_id = ''
      return showError(message)
    }
    projects.value = data.project_masters
    formData.value.contact_profile_id = data.id
    activeContactProfile.value = {
      id: data.id,
      full_name: data.full_name
    };
  }).catch((e) => {
    console.log(e)
  }).finally(() => loading.value = false);
}

const getQuery = () => {
  let query = '?company_id=' + companyId.value
  query += '&date=' + formData.value.date
  if (formData.value.contactProfile) query += `&contact_profile_id=${formData.value.contactProfile.id}`;
  if (formData.value.project) query += `&project_id=${formData.value.project.id}`;
  return query
}

onMounted(() => {
  formData.value.date = new Date().toISOString().split('T')[0]
  getContactWithProjects();
  getCompanyRoles();
  getModalList();
})
</script>

<style scoped>
.total-color {
  color: #7367f0;
}
.current-color {
  color: #28c76f;
}
.col-group {
  width: 8%;
}
.col-activity-name {
  width: 15%;
}
.col-measurement {
  width: 5%;
}
.col-narrow {
  width: 8%;
}
.col-note {
  width: 27%;
}
.col-calendar {
  width: 5%;
}
</style>
